/* ============================================================
   ATHLO+ reviews — storefront client for our own reviews backend
   (Supabase functions/v1/reviews).

   Renders on any element carrying data-athlo-reviews:
     <div data-athlo-reviews data-target-type="product|service|insight"
          data-target-id="{{ product.id }}"></div>

   Shows approved reviews + summary (public), and — for a signed-in
   member — the right state: sign in / unlocks after you buy this /
   you've reviewed this / a submit form. NOTHING it submits is public:
   the backend pre-moderates and a human approves.

   Inert-safe: no-ops when the endpoint isn't set or there are no
   widgets on the page. ES5-safe (no optional chaining / nullish).
   User-supplied text is only ever written via textContent.
   ============================================================ */
(function () {
  'use strict';
  var B = document.body;
  var EP = (B.getAttribute('data-reviews-endpoint') || '').trim();   // direct Supabase URL (token auth)
  var PROXY = (B.getAttribute('data-reviews-proxy') || '').trim();   // App Proxy path (preferred, if set)
  var MEMBER = (B.getAttribute('data-member-id') || '').trim();
  var USE_PROXY = !!PROXY;
  var BASE = USE_PROXY ? PROXY : EP;
  if (!BASE) return;

  var widgets = document.querySelectorAll('[data-athlo-reviews]');
  if (!widgets.length) return;

  // Call-time, HubSession-first (never a module-scope capture — the mint may not
  // have landed at load). Mirrors hub-loyalty.js's proven reader pattern.
  function lockerToken() {
    try {
      var s = window.HubSession;
      return ((s && typeof s.token === 'function' && s.token()) ||
              (B.getAttribute('data-locker-token') || '')).trim();
    } catch (e) { return ''; }
  }
  function authHeaders() {
    var h = { 'content-type': 'application/json' };
    if (!USE_PROXY && MEMBER) {
      var t = lockerToken();
      h['x-athlo-member'] = MEMBER;
      if (t) h['x-athlo-token'] = t;   // refuse to send an empty token
    }
    return h;
  }
  var LOGGED_IN = !!MEMBER;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function stars(rating) {
    var n = Number(rating), s = '';
    if (!isFinite(n) || n < 1) return '';
    for (var i = 1; i <= 5; i++) s += (i <= n) ? '★' : '☆';
    return s;
  }

  function getJSON(qs) {
    return fetch(BASE + qs, { headers: authHeaders(), credentials: 'omit' })
      .then(function (r) { return r.json().catch(function () { return { ok: false, error: 'bad_json' }; }); })
      .catch(function () { return { ok: false, error: 'network' }; });
  }
  function postJSON(obj) {
    return fetch(BASE, { method: 'POST', headers: authHeaders(), body: JSON.stringify(obj) })
      .then(function (r) { return r.json().catch(function () { return { ok: false, error: 'bad_json' }; }); })
      .catch(function () { return { ok: false, error: 'network' }; });
  }

  for (var i = 0; i < widgets.length; i++) initWidget(widgets[i]);

  function initWidget(host) {
    var tt = (host.getAttribute('data-target-type') || 'product').trim();
    var tid = (host.getAttribute('data-target-id') || '').trim();
    if (tt !== 'insight' && !tid) return;               // needs a target
    host.textContent = '';
    var listBox = el('div', 'rvw__list');
    var ctaBox = el('div', 'rvw__cta');
    host.appendChild(ctaBox);
    host.appendChild(listBox);
    loadList(listBox, tt, tid);
    loadCta(ctaBox, listBox, tt, tid);
  }

  function loadList(box, tt, tid) {
    if (tt === 'insight' && !tid) return;
    getJSON('?action=list&target_type=' + encodeURIComponent(tt) + '&target_id=' + encodeURIComponent(tid)).then(function (j) {
      box.textContent = '';
      if (!j || !j.ok) return;                          // silent: no reviews block if backend down
      var sum = j.summary || { count: 0, average: 0 };
      if (sum.count > 0 && tt !== 'insight') {
        var head = el('div', 'rvw__summary');
        head.appendChild(el('span', 'rvw__avg', String(sum.average)));
        var st = el('span', 'rvw__avgstars'); st.textContent = stars(Math.round(sum.average)); head.appendChild(st);
        head.appendChild(el('span', 'rvw__count', sum.count + (sum.count === 1 ? ' review' : ' reviews')));
        box.appendChild(head);
      }
      var reviews = j.reviews || [];
      for (var k = 0; k < reviews.length; k++) box.appendChild(reviewEl(reviews[k], tt));
    });
  }

  function reviewEl(r, tt) {
    var card = el('div', 'rvw__item');
    var meta = el('div', 'rvw__meta');
    if (tt !== 'insight' && r.rating) { var s = el('span', 'rvw__stars'); s.textContent = stars(r.rating); meta.appendChild(s); }
    meta.appendChild(el('span', 'rvw__author', r.author || 'Verified member'));
    if (r.featured) meta.appendChild(el('span', 'rvw__badge', 'Featured'));
    card.appendChild(meta);
    if (r.title) card.appendChild(el('div', 'rvw__title', r.title));
    card.appendChild(el('p', 'rvw__body', r.body || ''));
    return card;
  }

  function loadCta(box, listBox, tt, tid) {
    box.textContent = '';
    if (!LOGGED_IN) {
      var a = el('a', 'rvw__signin', tt === 'insight' ? 'Sign in to share your insight' : 'Sign in to review');
      a.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'account/login';
      box.appendChild(a);
      return;
    }
    if (tt === 'insight') { renderForm(box, listBox, tt, tid); return; }
    getJSON('?action=eligibility&target_type=' + encodeURIComponent(tt) + '&target_id=' + encodeURIComponent(tid)).then(function (j) {
      box.textContent = '';
      var state = (j && j.ok && j.state) ? j.state : 'locked';
      if (state === 'can_review') { renderForm(box, listBox, tt, tid); return; }
      if (state === 'already') { box.appendChild(el('p', 'rvw__note', '✓ You’ve reviewed this — thanks.')); return; }
      if (state === 'sign_in') { box.appendChild(el('p', 'rvw__note', 'Sign in to review.')); return; }
      var lock = el('p', 'rvw__note rvw__locked');
      lock.textContent = tt === 'service'
        ? '🔒 Reviews unlock after you complete this session.'
        : '🔒 Reviews unlock after you buy this.';
      box.appendChild(lock);
    });
  }

  function renderForm(box, listBox, tt, tid) {
    box.textContent = '';
    var form = el('form', 'rvw__form');
    var heading = el('div', 'rvw__formhead', tt === 'insight' ? 'Share your insight' : 'Write a review');
    form.appendChild(heading);

    var ratingInput = null;
    if (tt !== 'insight') {
      var rw = el('div', 'rvw__rating');
      rw.setAttribute('role', 'radiogroup');
      rw.setAttribute('aria-label', 'Rating out of 5');
      var chosen = 0;
      var btns = [];
      var setStars = function (v) {
        chosen = v;
        for (var b = 0; b < btns.length; b++) {
          btns[b].textContent = (b < v) ? '★' : '☆';
          btns[b].setAttribute('aria-checked', (b + 1) === v ? 'true' : 'false');
        }
      };
      for (var n = 1; n <= 5; n++) {
        (function (v) {
          var sb = el('button', 'rvw__star');
          sb.type = 'button'; sb.textContent = '☆';
          sb.setAttribute('role', 'radio'); sb.setAttribute('aria-label', v + ' star' + (v > 1 ? 's' : ''));
          sb.addEventListener('click', function () { setStars(v); });
          btns.push(sb); rw.appendChild(sb);
        })(n);
      }
      form.appendChild(rw);
      ratingInput = { get: function () { return chosen; } };
    }

    var title = el('input', 'rvw__input');
    title.type = 'text'; title.maxLength = 120; title.placeholder = tt === 'insight' ? 'A short headline (optional)' : 'Title (optional)';
    form.appendChild(title);

    var body = el('textarea', 'rvw__textarea');
    body.rows = 4; body.maxLength = 5000; body.required = true;
    body.placeholder = tt === 'insight' ? 'What actually works for you? Keep it real and kind.' : 'How was it? Be specific and fair.';
    form.appendChild(body);

    var msg = el('p', 'rvw__msg'); msg.style.display = 'none';
    var submit = el('button', 'rvw__submit', 'Submit for review');
    submit.type = 'submit';
    form.appendChild(submit);
    form.appendChild(el('p', 'rvw__fineprint', 'Reviews are checked before they go live.'));
    form.appendChild(msg);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var text = (body.value || '').trim();
      if (text.length < 3) { showMsg(msg, 'err', 'Please write a little more.'); return; }
      if (ratingInput && ratingInput.get() < 1) { showMsg(msg, 'err', 'Please pick a rating.'); return; }
      // Don't fire a submit we can't authenticate: in proxy mode the cookie carries identity,
      // otherwise a locker token must be present. No token -> say so rather than send into the void.
      var tok = USE_PROXY ? 'ok' : lockerToken();
      if (!tok) { showMsg(msg, 'err', 'Please sign in again to post your review.'); return; }
      submit.disabled = true; submit.textContent = 'Submitting…';
      var payload = { action: 'submit', target_type: tt, target_id: tid, title: (title.value || '').trim(), body: text };
      if (ratingInput) payload.rating = ratingInput.get();
      postJSON(payload).then(function (j) {
        if (j && j.ok) {
          box.textContent = '';
          box.appendChild(el('p', 'rvw__note rvw__thanks', j.message || 'Thanks — your review is in the queue and goes live once approved.'));
          return;
        }
        submit.disabled = false; submit.textContent = 'Submit for review';
        var err = (j && j.error) || 'error';
        var copy = {
          rejected: 'That didn’t pass our content check. Please rephrase without profanity, links or personal details.',
          not_eligible: 'Only verified buyers can review this.',
          already_reviewed: 'You’ve already reviewed this.',
          rate_limited: 'You’re going a bit fast — try again in a moment.',
          not_logged_in: 'Please sign in again.',
          bad_token: 'Please sign in again.'
        };
        showMsg(msg, 'err', copy[err] || 'Sorry, something went wrong. Please try again.');
      });
    });

    box.appendChild(form);
  }

  function showMsg(node, tone, text) {
    node.textContent = text;
    node.className = 'rvw__msg rvw__msg--' + tone;
    node.style.display = 'block';
  }
})();
